/**
 * CodeSkin Shop All — mobile full-screen filter sheet (delegated; survives AJAX section swaps).
 */
(function () {
  var keyHandlerRoot = null;

  function getCollectionRoot(el) {
    if (!el || !el.closest) return null;
    var root = el.closest('.codeskin-shop-collection');
    if (root) return root;
    var wrap = el.closest('.codeskin-col-filter-form-wrap');
    if (!wrap || !wrap.classList.contains('is-portaled')) return null;
    var sectionId = wrap.getAttribute('data-codeskin-portal-section');
    if (sectionId) {
      return document.querySelector('.codeskin-shop-collection[data-section-id="' + sectionId + '"]');
    }
    return document.querySelector('.codeskin-shop-collection');
  }

  function getFilterWrap(root) {
    if (!root) return null;
    var wrap = root.querySelector('.codeskin-col-filter-form-wrap');
    if (wrap) return wrap;
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return null;
    return document.querySelector(
      '.codeskin-col-filter-form-wrap.is-portaled[data-codeskin-portal-section="' + sectionId + '"]'
    );
  }

  function isMobileFilterViewport() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function portalFilterWrap(root) {
    if (!root || !isMobileFilterViewport()) return;
    var wrap = root.querySelector('.codeskin-col-filter-form-wrap');
    if (!wrap || wrap.classList.contains('is-portaled')) return;
    var sectionId = root.getAttribute('data-section-id');
    wrap.classList.add('is-portaled');
    if (sectionId) {
      wrap.setAttribute('data-codeskin-portal-section', sectionId);
    }
    document.body.appendChild(wrap);
  }

  function restoreFilterWrap(root) {
    if (!root) return;
    var wrap = getFilterWrap(root);
    if (!wrap || !wrap.classList.contains('is-portaled')) return;
    var filtersBlock = root.querySelector('.col-side-block--filters');
    if (filtersBlock) {
      filtersBlock.appendChild(wrap);
    }
    wrap.classList.remove('is-portaled');
    wrap.removeAttribute('data-codeskin-portal-section');
  }

  function getFilterSheet(root) {
    var wrap = getFilterWrap(root);
    return wrap ? wrap.querySelector('[data-codeskin-col-filter-sheet]') : null;
  }

  function reparentStrayFilterWraps() {
    document.querySelectorAll('.codeskin-col-filter-form-wrap.is-portaled').forEach(function (wrap) {
      var sectionId = wrap.getAttribute('data-codeskin-portal-section');
      var root = sectionId
        ? document.querySelector('.codeskin-shop-collection[data-section-id="' + sectionId + '"]')
        : null;
      if (!root) {
        root = document.querySelector('.codeskin-shop-collection');
      }
      var filtersBlock = root && root.querySelector('.col-side-block--filters');
      if (filtersBlock) {
        filtersBlock.appendChild(wrap);
      }
      wrap.classList.remove('is-portaled');
      wrap.removeAttribute('data-codeskin-portal-section');
    });
  }

  function initSheetDropdowns(root) {
    var scope = getFilterWrap(root);
    if (!scope) return;
    scope.querySelectorAll('[data-codeskin-sheet-dropdown]').forEach(function (block) {
      if (block.dataset.sheetDropdownBound === 'true') return;
      var trigger = block.querySelector('[data-codeskin-sheet-dropdown-trigger]');
      var panel = block.querySelector('[data-codeskin-sheet-dropdown-panel]');
      var labelEl = block.querySelector('[data-codeskin-sheet-dropdown-label]');
      if (!trigger || !panel) return;
      block.dataset.sheetDropdownBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = panel.hidden;
        closeSheetDropdowns(root);
        if (typeof window.closeAllCodeskinFilterDropdowns === 'function') {
          window.closeAllCodeskinFilterDropdowns(null);
        }
        panel.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        block.classList.toggle('is-open', willOpen);
        if (willOpen) {
          window.requestAnimationFrame(function () {
            block.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        }
      });

      panel.querySelectorAll('[data-codeskin-col-filter-nav]').forEach(function (link) {
        link.addEventListener('click', function () {
          var text = link.getAttribute('data-filter-label') || link.textContent.trim();
          if (labelEl && text) labelEl.textContent = text;
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          block.classList.remove('is-open');
        });
      });

      if (block.hasAttribute('data-codeskin-sheet-dropdown-nav')) {
        var activeLink = block.querySelector('.codeskin-col-filter-sheet__plain-link.is-active');
        if (labelEl && activeLink) {
          labelEl.textContent =
            activeLink.getAttribute('data-filter-label') ||
            activeLink.textContent.replace(/\s+/g, ' ').trim();
        }
      }

      if (block.hasAttribute('data-codeskin-sheet-dropdown-availability')) {
        syncAvailabilitySheetDropdown(scope);
        block.addEventListener(
          'change',
          function (event) {
            if (!event.target.matches('.checkmark-input')) return;
            syncAvailabilitySheetDropdown(scope);
          },
          true
        );
      }
    });
  }

  function syncAvailabilitySheetDropdown(scope) {
    if (!scope) return;
    var block = scope.querySelector('[data-codeskin-sheet-dropdown-availability]');
    if (!block) return;
    var labelEl = block.querySelector('[data-codeskin-sheet-dropdown-label]');
    if (!labelEl) return;

    var checked = block.querySelector('.checkmark-input:checked');
    if (checked) {
      var optionLabel = checked.closest('label');
      if (optionLabel) {
        labelEl.textContent = optionLabel.textContent.replace(/\s+/g, ' ').trim();
        return;
      }
    }
    labelEl.textContent = 'Select availability';
  }

  function closeSheetDropdowns(root) {
    var scope = getFilterWrap(root);
    if (!scope) return;
    scope.querySelectorAll('[data-codeskin-sheet-dropdown]').forEach(function (block) {
      var panel = block.querySelector('[data-codeskin-sheet-dropdown-panel]');
      var trigger = block.querySelector('[data-codeskin-sheet-dropdown-trigger]');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      block.classList.remove('is-open');
    });
  }

  function syncAvailabilityTriggerLabel(scope) {
    syncAvailabilitySheetDropdown(scope);
    if (!scope) return;
    var dropdown = scope.querySelector(
      '.codeskin-col-filter-sheet__facet-group--availability [data-codeskin-filter-dropdown]'
    );
    if (!dropdown) return;
    var labelEl = dropdown.querySelector('[data-codeskin-availability-trigger-label]');
    if (!labelEl) return;

    var checked = dropdown.querySelector('.checkmark-input:checked');
    if (checked) {
      var optionLabel = checked.closest('label');
      if (optionLabel) {
        labelEl.textContent = optionLabel.textContent.replace(/\s+/g, ' ').trim();
        return;
      }
    }
    labelEl.textContent = dropdown.classList.contains('is-active') ? 'Availability' : 'Select availability';
  }

  function prepareAvailabilityTrigger(scope) {
    if (!scope) return;
    var dropdown = scope.querySelector(
      '.codeskin-col-filter-sheet__facet-group--availability [data-codeskin-filter-dropdown]'
    );
    if (!dropdown || dropdown.dataset.availabilitySheetBound === 'true') return;
    dropdown.dataset.availabilitySheetBound = 'true';

    var trigger = dropdown.querySelector('.codeskin-filter-dropdown__trigger');
    if (!trigger) return;

    var labelEl = trigger.querySelector('[data-codeskin-availability-trigger-label]');
    if (!labelEl) {
      labelEl = document.createElement('span');
      labelEl.className = 'codeskin-col-filter-sheet__sheet-dropdown-trigger-label';
      labelEl.setAttribute('data-codeskin-availability-trigger-label', '');
      var chevron = trigger.querySelector('svg');
      trigger.textContent = '';
      trigger.appendChild(labelEl);
      if (chevron) trigger.appendChild(chevron);
    }

    syncAvailabilityTriggerLabel(scope);
    dropdown.addEventListener('change', function () {
      syncAvailabilityTriggerLabel(scope);
    }, true);
  }

  function getActiveNavLabel(root, type) {
    var scope = getFilterWrap(root) || root;
    var link = scope.querySelector(
      '.codeskin-col-filter-sheet__plain-link.is-active[data-filter-type="' + type + '"], .codeskin-col-filter-sheet__link.is-active[data-filter-type="' + type + '"]'
    );
    if (!link) return '';
    return link.getAttribute('data-filter-label') || link.textContent.trim();
  }

  function getActiveFacetLabels(root) {
    var labels = [];
    var scope = getFilterWrap(root) || root;
    scope.querySelectorAll('[data-codeskin-sheet-facets] [data-codeskin-filter-dropdown]').forEach(function (wrap) {
      if (wrap.closest('.codeskin-col-filter-sheet__facet-group--ingredient')) return;
      var key = wrap.getAttribute('data-filter-key') || '';
      if (key.indexOf('ingredient') !== -1) return;

      var trigger = wrap.querySelector('.codeskin-filter-dropdown__trigger');
      if (!trigger || !wrap.classList.contains('is-active')) return;

      var name = trigger.textContent.replace(/\s+/g, ' ').trim();
      if (!name) return;

      var panel = wrap.querySelector('[data-codeskin-filter-panel]');
      if (panel) {
        var checked = panel.querySelector('.checkmark-input:checked');
        if (checked) {
          var label = checked.closest('label');
          if (label) {
            var text = label.textContent.replace(/\s+/g, ' ').trim();
            if (text) {
              labels.push(name + ': ' + text);
              return;
            }
          }
        }
        var minInput = panel.querySelector('input[name*="filter.v.price.gte"]');
        var maxInput = panel.querySelector('input[name*="filter.v.price.lte"]');
        if (minInput || maxInput) {
          var minVal = minInput && minInput.value ? minInput.value : '';
          var maxVal = maxInput && maxInput.value ? maxInput.value : '';
          if (minVal || maxVal) {
            labels.push('Price: ₹' + (minVal || '499') + ' – ₹' + (maxVal || '…'));
            return;
          }
        }
      }

      labels.push(name);
    });

    var sheetPrice = scope.querySelector(
      '.codeskin-col-filter-sheet__facet-group--price .filter-price-range--sheet-flat'
    );
    if (sheetPrice) {
      var sheetMin = sheetPrice.querySelector('input[name*="filter.v.price.gte"]');
      var sheetMax = sheetPrice.querySelector('input[name*="filter.v.price.lte"]');
      var sheetMinVal = sheetMin && sheetMin.value ? sheetMin.value : '';
      var sheetMaxVal = sheetMax && sheetMax.value ? sheetMax.value : '';
      if (sheetMinVal || sheetMaxVal) {
        labels.push('Price: ₹' + (sheetMinVal || '499') + ' – ₹' + (sheetMaxVal || '…'));
      }
    }

    return labels;
  }

  function syncFilterSummary(root) {
    if (!root) return;
    var summary = root.querySelector('[data-codeskin-filter-summary]');
    if (!summary) return;

    var parts = [];
    var cat = getActiveNavLabel(root, 'category');
    var concern = getActiveNavLabel(root, 'concern');

    if (cat && cat !== 'All Products') parts.push(cat);
    if (concern) parts.push(concern);
    parts = parts.concat(getActiveFacetLabels(root));

    var text = parts.join(' · ');
    if (text.length > 72) {
      text = text.slice(0, 69) + '…';
    }
    summary.textContent = text;
    summary.hidden = !text;
  }

  function syncSheetFacetActiveStates(root) {
    var scope = getFilterWrap(root) || root;
    if (!scope) return;
    scope.querySelectorAll('.codeskin-col-filter-sheet__plain-list--facet .filter-option-item').forEach(function (item) {
      var input = item.querySelector('.checkmark-input');
      item.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function bindSheetFacetActiveSync(root) {
    var scope = getFilterWrap(root);
    var scrollEl = scope && scope.querySelector('.codeskin-col-filter-sheet__scroll');
    if (!scrollEl || scrollEl.dataset.facetActiveBound === 'true') return;
    scrollEl.dataset.facetActiveBound = 'true';

    scrollEl.addEventListener(
      'change',
      function (event) {
        if (!event.target.matches('.codeskin-col-filter-sheet__plain-list--facet .checkmark-input')) return;
        syncSheetFacetActiveStates(root);
      },
      true
    );
  }

  function bindSheetPriceFocusScroll(root) {
    var scope = getFilterWrap(root);
    var scrollEl = scope && scope.querySelector('.codeskin-col-filter-sheet__scroll');
    if (!scrollEl || scrollEl.dataset.priceFocusBound === 'true') return;
    scrollEl.dataset.priceFocusBound = 'true';

    scrollEl.addEventListener(
      'focusin',
      function (event) {
        var input = event.target;
        if (!input.matches('.codeskin-col-filter-sheet .price-inputs .field--input')) return;
        window.setTimeout(function () {
          var item = input.closest('.price-input-item') || input;
          if (item && item.scrollIntoView) {
            item.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }, 280);
      },
      true
    );
  }

  function openSheet(root) {
    if (!root) return;
    var sheet = getFilterSheet(root);
    var openBtn = root.querySelector('[data-codeskin-col-filter-open]');
    if (!sheet) return;

    portalFilterWrap(root);
    sheet = getFilterSheet(root);
    if (!sheet) return;

    initSheetDropdowns(root);
    prepareAvailabilityTrigger(getFilterWrap(root));
    bindSheetPriceFocusScroll(root);
    bindSheetFacetActiveSync(root);
    syncSheetFacetActiveStates(root);
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('codeskin-col-filter-open');

    var facetScope = getFilterWrap(root) || root;
    if (typeof window.initCodeskinFilterDropdowns === 'function') {
      window.initCodeskinFilterDropdowns(sheet);
    }

    syncFilterSummary(root);
  }

  function closeSheet(root) {
    if (!root) {
      document.documentElement.classList.remove('codeskin-col-filter-open');
      return;
    }

    var sheet = getFilterSheet(root);
    var openBtn = root.querySelector('[data-codeskin-col-filter-open]');

    if (sheet) {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');

    document.documentElement.classList.remove('codeskin-col-filter-open');

    if (typeof window.closeAllCodeskinFilterDropdowns === 'function') {
      window.closeAllCodeskinFilterDropdowns(null);
    }

    closeSheetDropdowns(root);
    syncFilterSummary(root);
    restoreFilterWrap(root);
  }

  function closeAllSheets() {
    document.querySelectorAll('.codeskin-shop-collection').forEach(closeSheet);
    document.documentElement.classList.remove('codeskin-col-filter-open');
    reparentStrayFilterWraps();
  }

  function onKeydown(event) {
    if (event.key !== 'Escape' || !keyHandlerRoot) return;
    closeSheet(keyHandlerRoot);
    keyHandlerRoot = null;
    document.removeEventListener('keydown', onKeydown);
  }

  function installDelegation() {
    if (document.documentElement.dataset.codeskinColFilterDelegation === 'true') return;
    document.documentElement.dataset.codeskinColFilterDelegation = 'true';

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-codeskin-sheet-dropdown]') &&
          !event.target.closest('.codeskin-col-filter-sheet__facet-group--availability')) {
        document.querySelectorAll('.codeskin-shop-collection').forEach(closeSheetDropdowns);
      }
      var openBtn = event.target.closest('[data-codeskin-col-filter-open]');
      if (openBtn) {
        var root = getCollectionRoot(openBtn);
        if (!root) return;
        event.preventDefault();
        event.stopPropagation();
        keyHandlerRoot = root;
        openSheet(root);
        document.addEventListener('keydown', onKeydown);
        return;
      }

      var closeEl = event.target.closest('[data-codeskin-col-filter-close]');
      if (closeEl) {
        var closeRoot = getCollectionRoot(closeEl);
        if (closeRoot) {
          event.preventDefault();
          event.stopPropagation();
          closeSheet(closeRoot);
          keyHandlerRoot = null;
          document.removeEventListener('keydown', onKeydown);
        }
        return;
      }

      var navLink = event.target.closest('[data-codeskin-col-filter-nav]');
      if (navLink) {
        var navRoot = getCollectionRoot(navLink);
        if (navRoot) {
          closeSheet(navRoot);
          keyHandlerRoot = null;
          document.removeEventListener('keydown', onKeydown);
        }
      }
    });

    document.addEventListener(
      'change',
      function (event) {
        var root = getCollectionRoot(event.target);
        if (!root || !event.target.closest('[data-codeskin-filter-form]')) return;
        window.setTimeout(function () {
          syncAvailabilityTriggerLabel(getFilterWrap(root));
          syncFilterSummary(root);
        }, 60);
      },
      true
    );

    document.addEventListener(
      'input',
      function (event) {
        var root = getCollectionRoot(event.target);
        if (!root || !event.target.closest('[data-codeskin-filter-form]')) return;
        window.setTimeout(function () {
          syncAvailabilityTriggerLabel(getFilterWrap(root));
          syncFilterSummary(root);
        }, 60);
      },
      true
    );
  }

  window.codeskinCloseCollectionFilterSheet = function (scope) {
    if (scope && scope.classList && scope.classList.contains('codeskin-shop-collection')) {
      closeSheet(scope);
      return;
    }
    if (scope) {
      scope.querySelectorAll('.codeskin-shop-collection').forEach(closeSheet);
    } else {
      closeAllSheets();
    }
    keyHandlerRoot = null;
    document.removeEventListener('keydown', onKeydown);
  };

  window.initCodeskinCollectionMobileFilters = function (scope) {
    reparentStrayFilterWraps();
    installDelegation();
    (scope || document).querySelectorAll('.codeskin-shop-collection').forEach(function (root) {
      initSheetDropdowns(root);
      prepareAvailabilityTrigger(getFilterWrap(root));
      bindSheetPriceFocusScroll(root);
      bindSheetFacetActiveSync(root);
      syncSheetFacetActiveStates(root);
      syncFilterSummary(root);
    });
  };

  window.codeskinSyncCollectionFilterSummary = function (scope) {
    (scope || document).querySelectorAll('.codeskin-shop-collection').forEach(syncFilterSummary);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reparentStrayFilterWraps();
      installDelegation();
    });
  } else {
    reparentStrayFilterWraps();
    installDelegation();
  }
})();
